import { z } from 'zod';

import { DiscountRuleWritableShape } from '../discount-rule-create/discount-rule-create';

/**
 * Editing a rule (`courses.manage`).
 *
 * `source` and `sourceId` are absent: the rule's reason for existing does not
 * move. Everything else may change, and matrix row 18 defines what that means —
 * existing grants are untouched because they snapshot their value at issuance;
 * only future events see the new rule.
 */
export const DiscountRuleUpdateSchema = z.object(DiscountRuleWritableShape).partial().strict();

export type DiscountRuleUpdateRequest = z.infer<typeof DiscountRuleUpdateSchema>;
